module.exports = __webpack_public_path__ + "static/img/menage7.e776232b.png";